var fn = function( obj ){
var __t,__p='';
__p+='precision highp float;\n\nvarying vec2 vTexCoord0;\nuniform sampler2D tTex;\nuniform float uAlpha;\n\nvoid main(void) {\n  vec3 color = vec3(1.0);\n  float alpha = texture2D(tTex, vTexCoord0).r * 5.0 * uAlpha;\n  gl_FragColor = vec4(color, alpha);\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
